import { RenderLeafProps } from 'slate-react';

import { CODE_TOKEN_CLASS } from './codeHighlight';

const Leaf = ({ attributes, children, leaf }: RenderLeafProps) => {
  if (leaf.code) {
    return (
      <span
        className={leaf.tokenType ? CODE_TOKEN_CLASS[leaf.tokenType] : undefined}
        {...attributes}
      >
        {children}
      </span>
    );
  }

  if (leaf.tag) {
    return (
      <span className="text-primary font-medium" {...attributes}>
        {children}
      </span>
    );
  }

  if (leaf.bold) {
    children = <strong>{children}</strong>;
  }

  if (leaf.italic) {
    children = <em>{children}</em>;
  }

  if (leaf.underline) {
    children = <u>{children}</u>;
  }

  return <span {...attributes}>{children}</span>;
};

export default Leaf;
